/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type { CliLoginResponse } from './cliLoginResponse';

export type GenericApiResponseCliLoginResponseData = CliLoginResponse | null;
